import React from 'react';
import XlsxImportModal from '../../components/XlsxImportModal';
import { importTips, ImportTipsResult, TIP_IMPORT_TEMPLATE_PATH } from '../../api/tips';

interface Props {
    open: boolean;
    onClose: () => void;
    /** 导入直接入库成功后回调 (走审批流时数据未变, 不触发) */
    onImported?: () => void;
}

// 小贴士批量导入 (xlsx): 交互全在通用 XlsxImportModal 里, 这里只绑模板/上传接口与结果口径.
// 一行 = 一个条目 + 它的挂载目标, 故结果计数是「新建条目 / 复用 / 新增挂载」而不是 upsert 的新建/更新.
const TipImportModal = ({ open, onClose, onImported }: Props) => (
    <XlsxImportModal<ImportTipsResult>
        open={open}
        onClose={onClose}
        onImported={onImported}
        title="批量导入小贴士 (xlsx)"
        templatePath={TIP_IMPORT_TEMPLATE_PATH}
        templateName="tip-import-template.xlsx"
        upload={importTips}
        hint={
            <>
                一行 = <b>一个条目 + 它的挂载目标</b>。模板里附了「填写说明」和「字段说明」两个
                sheet（逐列的必填/取值/多值/留空含义/示例），<b>下载后先看这两页</b>。
                <br />
                挂载目标三列可混填、取并集：「一级分类」多个 = 每个整片挂；「一级分类」填 1
                个 +「二级分类」多个 = 只挂这几个二级；「材料ID」直选。多值用逗号/顿号分隔。
                三列全留空 = <b>只建条目不挂载</b>，之后用「批量挂载」再挂。
                <br />
                条目身份是「标题 + 补充说明」：库里已有完全相同的 →{' '}
                <b>直接引用不建副本、也不改已有内容</b>；标题相同但说明不同 = 两个不同条目，照常新建。
            </>
        }
        renderStats={(r) =>
            r.created === undefined ? null : (
                <span className="text-slate-500">
                    新建条目 {r.created} · 复用 {r.reused ?? 0} · 新增挂载 {r.mounted ?? 0}
                    {(r.resolved ?? 0) > (r.mounted ?? 0) &&
                        ` (目标 ${r.resolved} 个材料, 其余已挂载)`}
                </span>
            )
        }
    />
);

export default TipImportModal;
